/*
 * @Author: QY
 * @Date: 2022-04-07 14:36:46
 * @LastEditors: DQL
 * @LastEditTime: 2022-04-08 17:19:16
 * @Description: file content
 */
const vacationListRoutes = {
  path: 'vacationList',
  name: 'vacationList',
  component: () => import(/* webpackChunkName: "vacationList" */ '@/features/attendance/vacationList/list.vue'),
  meta: {
    navtabTitle: '员工假期统计',
    isCache: true,
    ignoreDiff: [],
    menuElements: []
  }
};

export default vacationListRoutes;
